import {Grid} from "@mui/material";
import Paper from "@mui/material/Paper";
import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import EnhancedConfirmButton from "../enhanced/EnhancedConfirmButton";
import EnhancedTextField from "../enhanced/EnhancedTextField";
import PasswordChecklist from "react-password-checklist";
import {changeUserPassword} from "../../features/usersSlice";
import alertHelper from "../../helpers/alertHelper";

function UserChangePassword() {
  const dispatch = useDispatch();
  const [isPasswordValid, setPasswordValid] = useState(true);
  const [isPasswordChanged, setPasswordChanged] = useState(false);
  const [formState, setFormState] = useState({});

  useEffect(() => {
    if (isPasswordChanged) {
      alertHelper.successDialog({
        message: 'Vaše heslo bylo změněno'
      });
      setFormState('');
    }
  }, [isPasswordChanged, formState]);

  const handleChange = (event) => {
    event.persist();
    setFormState((formState) => ({
      ...formState,
      [event.target.name]: event.target.value
    }));
  };

  const handleChangePassword = () => {

    if (formState.password === '' && formState.passwordConfirm === '' && formState.oldPassword === '') {
      alertHelper.error({ message: "Hesla jsou prázdná!" });
      return false;
    }

    if (!isPasswordValid) {
      alertHelper.error({ message: "Hesla nejsou validní!" });
      return false;
    }

    const apiData = {
      oldPassword: formState.oldPassword,
      newPassword: formState.password,
      confirmPassword: formState.passwordConfirm
    };

    dispatch(changeUserPassword(apiData));

    setPasswordChanged(true);
  }

  const isDisable = () => {
    return !isPasswordValid;
  }

  return (
      <div>
        <Paper>
          <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              sx={{ marginTop: 0, padding: 5 }}
          >
            <div>
              <h2>Nastavte si nové heslo</h2>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <PasswordChecklist
                      rules={["notEmpty","minLength","specialChar","number","capital","match"]}
                      minLength={8}
                      value={formState.password || ''}
                      valueAgain={formState.passwordConfirm || ''}
                      messages={{
                        notEmpty: "Hesla jsou vyplněná.",
                        minLength: "Heslo má alespoň 8 znaků.",
                        specialChar: "Heslo obsahuje speciální znaky.",
                        number: "Heslo obsahuje číslici.",
                        capital: "Heslo obsahuje velké písmeno.",
                        match: "Hesla se shodují.",
                      }}
                      onChange={(isValid) => {
                        setPasswordValid(isValid);
                      }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <EnhancedTextField
                      name="oldPassword"
                      value={formState.oldPassword || ''}
                      label="Staré heslo"
                      onChange={handleChange}
                      maxLength="90"
                      type="password"
                  />
                </Grid>
                <Grid item xs={12}>
                  <EnhancedTextField
                      name="password"
                      value={formState.password || ''}
                      label="Nové heslo"
                      onChange={handleChange}
                      maxLength="90"
                      type="password"
                  />
                </Grid>
                <Grid item xs={12}>
                  <EnhancedTextField
                      name="passwordConfirm"
                      value={formState.passwordConfirm || ''}
                      label="Heslo pro potvrzení"
                      onChange={handleChange}
                      maxLength="90"
                      type="password"
                  />
                </Grid>
                <Grid item xs={12}>
                  <EnhancedConfirmButton
                      handleOk={handleChangePassword}
                      okLabel="Změnit heslo"
                      disabledOk={isDisable()}
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Paper>
      </div>
  );
}
export default UserChangePassword;
